// @flow
import React, {PureComponent} from 'react';

import BackgroundImage from 'components/fragments/BackgroundImage';

export type StateProps = {
  datas: Object
};

type Props = StateProps;

class TeamMenuPOTM extends PureComponent<Props> {

  render() {

    return (this.props.datas && <div className="col col-md-6 col-lg-3">
      <a href={this.props.datas.boutique.link} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="box card card--picture box--white">
        <BackgroundImage 
          className="card__thumbnail img-blue" 
          illustration={this.props.datas.boutique.featured_image} 
          srcset={this.props.datas.boutique.srcset} />
        <div className="card__body">
          <h3 className="card__title">Boutique officielle</h3>
          <p className="card__desc ft-h6 ft-up ft-truncat">{this.props.datas.boutique.nom}</p>
        </div>
        <div className="card__footer">
          <span className="link-chevron ">Accéder à la boutique<i className="icon icon-chevron-right"></i>
          </span>
        </div>
      </a>
    </div>);
  }
};

export default TeamMenuPOTM;
